import styles from "./sharedDataPopup.module.scss";
import Button from "../button/Button";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  handleDraftPopup,
  // handleStagAndProdPopup,
  handleSaveToActionItems,
  sdStates,
  resetFormInputValues
} from "../../pages/sharedData/sharedDataSlice";
import Popup from "./Popup";

const SharedDataPopup = ({
  onAbort,
  onSuccess,
  action,
  state,
  revisionNumbers = [],
  emailExist = false,
}) => {
  const [emails, setEmails] = useState({
    emailItems: "",
    emailError: "",
  });
  const [formInputValues, setFormInputValues] = useState({
    reasonForChange: "",
    reasonForChangeError: "",
    selectedRevisionNumbers: [],
  });
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();
  const valuesArray = revisionNumbers.reduce(
    (acc, curr, index) => (
      index % 2 === 0 ? acc.push([curr]) : acc[acc.length - 1].push(curr), acc
    ),
    []
  );

  const checkValidation = (emailList) => {
    let isValid = true;
    if (!formInputValues.reasonForChange) {
      setFormInputValues((prevState) => ({
        ...prevState,
        reasonForChangeError: "Comment section cannot be empty",
      }));
      isValid = false;
    }

    if (emails.emailItems) {
      let mailformat = /^\w+([\.-]?\w+)@\w+([\.-]?\w+)(\.\w{2,3})+$/;
      const validEmails = emailList.every((email) => mailformat.test(email));
      if (!validEmails) {
        setEmails((prevState) => ({
          ...prevState,
          emailError: "Enter valid email",
        }));
        isValid = false;
      }
    }
    return isValid;
  };

  const handleChange = (setFormInputValues, e) => {
    const { name, value, checked } = e.target;
    if (name === "emails") {
      setEmails({
        emailItems: value,
        emailError: "",
      });
    } else if (name === "input") {
      setFormInputValues((prevState) => ({
        ...prevState,
        reasonForChange: value,
        reasonForChangeError: "",
      }));
    } else if (name === "revisionNumbers") {
      if (checked) {
        setFormInputValues((prevState) => ({
          ...prevState,
          selectedRevisionNumbers: [
            ...prevState.selectedRevisionNumbers,
            value,
          ],
        }));
      } else {
        const filteredArray = formInputValues.selectedRevisionNumbers.filter(
          (item) => item !== value
        );
        setFormInputValues((prevState) => ({
          ...prevState,
          selectedRevisionNumbers: filteredArray,
        }));
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let emailList = [];
    if (emails.emailItems) {
      emailList = emails.emailItems
        .split(",")
        .filter((item) => item.trim())
        .map((item) => item.trim());
    }
    const isValid = checkValidation(emailList);
    if (isValid) {
      const reasonForChangeObj = {
        comment: formInputValues.reasonForChange,
        date: new Date().toISOString()
      };
      if (state === sdStates.draft) {
        let emailInfo = {};
        if (emailList.length > 0) {
          emailInfo["emails"] = emailList;
          emailInfo["user"] = "Sahana";
        }
        const draftPayload = {
          action,
          saveToState: state,
          emailInfo,
          input: {
            ...formInputValues,
            reasonForChange: JSON.stringify(reasonForChangeObj),
          },
          onSuccess,
        };
        console.log("[SharedDataPopup] handleDraftPopup payload:", draftPayload);
        dispatch(handleDraftPopup(draftPayload));
      } else {
        if (
          state === sdStates.production &&
          formInputValues.selectedRevisionNumbers.length > 0
        ) {
          setShowPopup(true);
        } else {
          const savePayload = {
            input: {
              ...formInputValues,
              reasonForChange: JSON.stringify(reasonForChangeObj),
            },
            saveToState: state,
            onSuccess,
            onAbort,
          };
          console.log("[SharedDataPopup] handleSaveToActionItems payload:", savePayload);
          dispatch(handleSaveToActionItems(savePayload));
        }
      }
      dispatch(resetFormInputValues())
    }
  };

  return (
    <div className={styles.layout}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.title}>
            {" "}
            The shared data for this product will be submitted to the Reviewer for CoolCloud Test approval.{" "}
            {/* <span className={styles.state}>{state}</span>.  */}
            Are you sure everything is correct?
          </div>
          {revisionNumbers.length > 0 && (
            <div>
              <div className={styles.revisionText}>
                We found the below previous revisions in the{" "}
                <span className={styles.state}>{state}</span> for this model
                number. Please select the ones which needs to be updated with
                this new shared data in the{" "}
                <span className={styles.state}>{state}</span>.
              </div>
              <table>
                <tbody className={styles.tableBody}>
                  {valuesArray.map((valArray) => {
                    return (
                      <tr className={styles.tr} key={JSON.stringify(valArray)}>
                        {valArray.map((value) => {
                          return (
                            <td
                              className={styles.td}
                              key={JSON.stringify(value)}
                            >
                              <input
                                name="revisionNumbers"
                                className={styles.checkbox}
                                type="checkbox"
                                onChange={(e) =>
                                  handleChange(setFormInputValues, e)
                                }
                                value={value.ModelNumber}
                                checked={formInputValues.selectedRevisionNumbers.includes(
                                  value.ModelNumber
                                )}
                              />
                              <span className={styles.text}>
                                {value.ModelNumber}
                              </span>
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          <div className={styles.confirmText}>
            Click 'Ok' to save or 'Cancel' to review.
          </div>
        </div>
        {emailExist && (
          <div>
            <p className={styles.emailInputHeader}>
              Would you like to notify your team to populate additional fields?
            </p>
            <textarea
              name="emails"
              type="text"
              className={styles.emailInput}
              value={emails.emailItems}
              onChange={(e) => handleChange(setFormInputValues, e)}
              placeholder="Enter your team's email IDs with comma sepearated"
            ></textarea>
            {emails.emailError && (
              <p className={styles.errorMessage}>{emails.emailError}</p>
            )}
          </div>
        )}
        <div>
          <p className={styles.summaryInputHeader}>
            Comments<span className={styles.star}>*</span>
          </p>
          <textarea
            name="input"
            className={styles.summaryInput}
            value={formInputValues.reasonForChange}
            onChange={(e) => handleChange(setFormInputValues, e)}
            placeholder="Enter the comment made to the shared data fields."
          ></textarea>
          {formInputValues.reasonForChangeError && (
            <p className={styles.errorMessage}>
              {formInputValues.reasonForChangeError}
            </p>
          )}
        </div>
        <div className={styles.footer}>
          <Button style={styles.cancel} onClick={onAbort}>
            Cancel
          </Button>
          <Button style={styles.send} onClick={handleSubmit}>
            Ok
          </Button>
        </div>
      </div>
      {showPopup && (
        <Popup
          title={
            <>
              You're about to save this shared data to{" "}
              <span className={styles.state}>{state}</span> of the selected
              previous revision(s) in addition to the current revision of the
              model. Are you sure everything is correct?
            </>
          }
          successText="Ok"
          description="Click 'Ok' to confirm or 'Cancel' to go back."
          onSuccess={() => {
            setShowPopup(false);
            const reasonForChangeObj = {
              comment: formInputValues.reasonForChange,
              date: new Date().toISOString()
            };
            const popupPayload = {
              input: {
                ...formInputValues,
                reasonForChange: JSON.stringify(reasonForChangeObj),
              },
              saveToState: state,
              onSuccess,
              onAbort,
            };
            console.log("[SharedDataPopup] Popup onSuccess payload:", popupPayload);
            dispatch(handleSaveToActionItems(popupPayload));
          }}
          onCancel={() => {
            setShowPopup(false);
          }}
        />
      )}
    </div>
  );
};

export default SharedDataPopup;
